import { render, staticRenderFns } from "./join-trends.vue?vue&type=template&id=785ba64e&scoped=true&"
import script from "./join-trends.vue?vue&type=script&lang=js&"
export * from "./join-trends.vue?vue&type=script&lang=js&"
import style0 from "./join-trends.vue?vue&type=style&index=0&id=785ba64e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785ba64e",
  null
  
)

export default component.exports